import { Record } from 'immutable';


export const RoomBrowseEntry = new Record({
  building: null,
  capacity: null,
  isAllocated: null,
  key: null,
  femaleOnly: null,
  maleOnly: null,
  roomCode: null,
  unit: null
});


// WEBPACK FOOTER //
// ./src/core/room-browse/room-browse-entry.js